var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { OrderDetailResolver } from './order-details/order-detail.resolver';
import { OrderListComponent } from './order-list/order-list.component';
import { OrderModule } from './../order/order.module';
import { DashboardUserMenuComponent } from './user-menu/dashboard-user-menu.component';
import { SharedModule } from './../components/shared.module';
import { DashboardSidebarComponent } from './sidebar/dashboard-sidebar.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DashboardComponent } from './dashboard.component';
import { dashboardRouting } from './dashboard.routing';
import { AuthGuard } from '../authguard.service';
import { DataSourceService } from '../modules/DB/datasource.service';
import { OrderDetailComponent } from './order-details/order-detail.component';
import { DashboardHomeComponent } from './home/dashboard-home.component';
var DashboardModule = (function () {
    function DashboardModule() {
    }
    DashboardModule = __decorate([
        NgModule({
            imports: [
                CommonModule,
                dashboardRouting,
                SharedModule,
                OrderModule
            ],
            declarations: [
                DashboardComponent,
                DashboardHomeComponent,
                DashboardSidebarComponent,
                DashboardUserMenuComponent,
                OrderDetailComponent,
                OrderListComponent
            ],
            providers: [
                AuthGuard,
                OrderDetailResolver,
                DataSourceService
            ]
        })
    ], DashboardModule);
    return DashboardModule;
}());
export { DashboardModule };
//# sourceMappingURL=dashboard.module.js.map


//////////////////
// WEBPACK FOOTER
// ./src/app/dashboard/dashboard.module.js
// module id = 800
// module chunks = 0